// extracted by mini-css-extract-plugin
export default {"container":"EventRoleEditModal_container__EkfPP"};